export default __webpack_public_path__ + "static/media/illu_event.36cb85d6.png";